export const Price = ({ children }) => {
  return <p className="price">Price : USD ${children}</p>;
};
